import chromeicon from 'assets/testdetailicons/Chrome.svg';
import edgeicon from 'assets/testdetailicons/edge.svg';
import explorericon from 'assets/testdetailicons/explorer.svg';
import firefoxicon from 'assets/testdetailicons/firefox.svg';
import operaicon from 'assets/testdetailicons/opera.svg';
import safariicon from 'assets/testdetailicons/safari.svg';

export const count = (
  selectedteststatus,
  selectedApproverOption,
  buttontext
) => {
  let count = 0;
  if (selectedteststatus.length > 0) {
    count += 1;
  }
  if (selectedApproverOption.length > 0) {
    count += 1;
  }
  if (buttontext !== 'Select Date Range') {
    count += 1;
  }
  return count;
};

export const Ellipsis = (value, length) => {
  return value.length <= length
    ? value
    : value?.substring(0, length).concat('...');
};

export const selectbrowsericonhandler = (e) => {
  let browser = e.toLowerCase();
  switch (browser) {
    case 'chrome':
      return chromeicon;

    case 'safari':
      return safariicon;

    case 'edge':
      return edgeicon;

    case 'microsoftedge':
      return edgeicon;

    case 'internet explorer':
      return explorericon;

    case 'opera':
      return operaicon;

    case 'firefox':
      return firefoxicon;

    default:
      return chromeicon;
  }
};

export function removeAriaRoles() {
  const elems = document.getElementsByClassName('ReactVirtualized__List');
  const elems2 = document.getElementsByClassName(
    'ReactVirtualized__Grid__innerScrollContainer'
  );
  const elems3 = document.getElementsByClassName('react-lazylog');

  for (let i = 0; i < elems.length; i++) {
    const e = elems[i];
    e.removeAttribute('role');
    e.removeAttribute('aria-readonly');
    e.removeAttribute('tabindex');
    e.removeAttribute('aria-label');
  }

  for (let i = 0; i < elems2.length; i++) {
    const e = elems2[i];
    e.removeAttribute('role');
    e.removeAttribute('aria-readonly');
    e.removeAttribute('tabindex');
    e.removeAttribute('aria-label');
  }

  for (let i = 0; i < elems3.length; i++) {
    const e = elems3[i];
    e.setAttribute('role', 'region');
    e.setAttribute('tabindex', '0');
    e.removeAttribute('aria-readonly');
  }
}

export function isFailFastJob(remark = '') {
  return remark.indexOf('fail fast') >= 0;
}
